// extracted by mini-css-extract-plugin
export default {"container":"WPHOt_container","add-btn-text":"w4w9q_add-btn-text","icon":"pGkQ9_icon"};